import { render, staticRenderFns } from "./MessageOutgoingSticker.vue?vue&type=template&id=3d8e641a&"
import script from "./MessageOutgoingSticker.vue?vue&type=script&lang=js&"
export * from "./MessageOutgoingSticker.vue?vue&type=script&lang=js&"
import style0 from "./MessageOutgoingSticker.vue?vue&type=style&index=0&id=3d8e641a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
